// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "75ee2b987eb65808033c8acfd8173fa2" + ".js";
};